import * as React from 'react'

import { Link } from '@factorialco/deprecated-design-system'

import { TrackingProperties, track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl, { HelpCenterNewRequest, HelpCenterUrl } from 'modules/core/lib/helpCenterUrl'

interface LinkPropsWithChildren extends React.ComponentProps<typeof Link> {
  children?: React.ReactNode
}
interface Props extends LinkPropsWithChildren {
  name: HelpCenterUrl | HelpCenterNewRequest
  link?: string | null | undefined
  trackingEvent?: string
  trackingProperties?: TrackingProperties
}

const HelpCenterLink: React.FC<Props> = ({
  link,
  name,
  children,
  trackingEvent,
  trackingProperties,
  type,
}: React.PropsWithChildren<Props>) => {
  const hrefLink = link ? link : helpCenterUrl(name)
  const onClick = () => {
    track(trackingEvent || trackingEvents.factorialTip.clickedTheTooltipLink, trackingProperties)
  }

  return (
    <Link.Href
      target="_blank"
      rel="noopener noreferrer"
      href={hrefLink}
      onClick={onClick}
      type={type}
    >
      {children}
    </Link.Href>
  )
}

export default HelpCenterLink
